import React, {type JSX} from 'react';

interface ErrorBoundaryProps {
  children?: React.ReactNode;
  renderError(e: Error, resetError: () => void): JSX.Element;
  onError?(e: Error, info: React.ErrorInfo): void;
  silent?: boolean;
}

interface ErrorBoundaryState {
  error: Error | null;
}

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return {error};
  }

  state: ErrorBoundaryState = {error: null};

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    if (!this.props.silent) {
      console.error('Encountered ErrorBoundary:', error);
    }
    this.props.onError?.(error, info);
  }

  render() {
    if (this.state.error != null) {
      const resetError = () => this.setState({error: null});
      return this.props.renderError(this.state.error, resetError);
    }

    return this.props.children;
  }
}
